export default __webpack_public_path__ + "static/media/img_maintenance_v1_screen.6aca0169.gif";